import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'mail-clock',
  size: 24,
  node: [
    ['path', { d: 'M16 14v2.2l1.6 1', key: 'fo4ql5' }],
    ['path', { d: 'm22 7-.759.484', key: '12ll7o' }],
    ['path', { d: 'M6.835 20H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v2', key: '1wt3ht' }],
    ['path', { d: 'M7.605 10.567 2 7', key: '1ducps' }],
    ['circle', { cx: '16', cy: '16', r: '6', key: 'qoo3c4' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name MailClock
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTR2Mi4ybDEuNiAxIiAvPgogIDxwYXRoIGQ9Im0yMiA3LS43NTkuNDg0IiAvPgogIDxwYXRoIGQ9Ik02LjgzNSAyMEg0YTIgMiAwIDAxLTItMlY2YTIgMiAwIDAxMi0yaDE2YTIgMiAwIDAxMiAydjIiIC8+CiAgPHBhdGggZD0iTTcuNjA1IDEwLjU2NyAyIDciIC8+CiAgPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/mail-clock
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MailClock = createLucideIcon(__iconData);

export default MailClock;
